import { Component, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Icons, Color, Orientation, Size } from '@lsq-frontend/common-ui';

@Component({
    selector: 'buyer-configuration-eligibility-setting-section',
    styleUrls: ['./buyer-configuration-eligibility-setting-section.component.scss'],
    template: `
        <div card-body class="implementation-card-body">
            <div class="agreement-structure-controls" [id]="enabledFormControl + 'SectionHeader'">
                <form class="control-inputs" [formGroup]="formGroup">
                    <div class="control-row" [style.marginBottom]="'1.8rem'">
                        <lsq-switch
                            [labelOrientation]="orientation.Right"
                            [formControlName]="enabledFormControl"
                            [name]="enabledFormControl"
                            [group]="formGroup"
                            [style.marginRight]="'0.5rem'"
                            [id]="enabledFormControl"
                        ></lsq-switch>
                        <div [style.width]="'100%'">
                            <div class="row">
                                <div class="col-12" [style.marginBottom]="'1rem'">
                                    <label
                                        [for]="label"
                                        class="p label"
                                        [style.marginBottom]="sublabel ? '0.2rem' : '1.2rem'"
                                        [style.paddingRight]="'0.4rem'"
                                    >
                                        {{ label }}
                                    </label>
                                    <popover-content #examplePopover [size]="size.MediumSmall">
                                        <b>Example:</b><br />If an invoice with NET 90 terms has an
                                        eligibility window of 60 days, the invoice must age 30 days
                                        before becoming eligible for early payment.
                                    </popover-content>
                                    <lsq-icon
                                        *ngIf="maxDaysPaid"
                                        [type]="icons.QuestionCircleLight"
                                        [popoverOnHover]="true"
                                        [height]="14"
                                        [width]="14"
                                        [color]="color.DarkGray"
                                        [style.marginLeft]="'0.2rem'"
                                        [popover]="examplePopover"
                                    >
                                    </lsq-icon>
                                    <p
                                        [style.marginBottom]="'0.2rem'"
                                        *ngIf="sublabel"
                                        [style.opacity]="disabled ? '0.5' : '1'"
                                    >
                                        {{ sublabel }}
                                    </p>
                                </div>
                            </div>
                            <div [style.width]="'100%'">
                                <div *ngIf="note" class="note" [lightBorder]="true">
                                    <p class="font-weight-400 text-dark-gray">
                                        {{ note }}
                                    </p>
                                </div>
                                <lsq-input
                                    [id]="activeFormControl + 'Input'"
                                    parentClass="full-space"
                                    [basicLabel]="true"
                                    [name]="activeFormControl"
                                    [formControlName]="activeFormControl"
                                    [group]="formGroup"
                                    [digitsOnly]="true"
                                ></lsq-input>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    `
})
export class AdminBuyerConfigurationEligibilitySection {
    @Input() public label: string;
    @Input() public sublabel: string;
    @Input() public enabledFormControl: FormControl;
    @Input() public activeFormControl: FormControl;
    @Input() public formGroup: FormGroup;
    @Input() public maxDaysPaid: Boolean = false;
    @Input() public note?: string;

    public readonly icons = Icons;
    public readonly color = Color;
    public readonly orientation = Orientation;
    public size = Size;
}
